module.exports = __webpack_public_path__ + "static/media/user-icon.1897f975.png";